/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";

function ActionCell({
  id,
  status,
  filters,
  handleEditAction,
  handleDeleteAction,
  handleApplyAction,
  handleCloneAction,
  handleCheckCloneAction,
}) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Edit Template Name" placement="top">
            <Icon onClick={handleEditAction}>edit</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>

      {/* <Link to={filters === "" ? "" : "/feed-settings/filters/filters-list/" + id}> */}
      <Link to={filters === "" ? "" : "/feed-settings/filters"} state={{ templateId: id }}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Go to Filters List" placement="top">
            <Icon className={filters == "" ? "disabled-form-item" : ""}>tune_outlined_icon</Icon>
          </Tooltip>
        </SoftTypography>
      </Link>
      <SoftBox mx={2} sx={{ display: handleCloneAction ? "" : "none" }}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{ cursor: filters == "" ? "" : "pointer", lineHeight: 0 }}
        >
          <Tooltip title="Clone Template" placement="top">
            <Icon
              className={filters == "" ? "disabled-form-item" : ""}
              onClick={filters == "" ? null : handleCloneAction}
            >
              content_copy_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{ cursor: filters == "" ? "" : "pointer", lineHeight: 0 }}
        >
          <Tooltip title="Check Clone Template to Another Platform" placement="top">
            <Icon
              className={filters == "" ? "disabled-form-item" : ""}
              onClick={filters == "" ? null : handleCheckCloneAction}
            >
              move_up_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color="secondary"
          sx={{ cursor: "pointer", lineHeight: 0, display: !status ? "" : "none" }}
        >
          <Tooltip title="Delete Template" placement="top">
            <Icon onClick={handleDeleteAction}>delete</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          color={filters === "" ? "info" : "success"}
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            display: !status ? "" : "none",
          }}
        >
          <Tooltip title="Apply Template" placement="top">
            <Icon onClick={handleApplyAction}>check</Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="body1"
          color="error"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            display: status ? "none" : "none",
          }}
        >
          <Tooltip title="Disable Template" placement="top">
            <Icon onClick={handleApplyAction}>close</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  id: PropTypes.number,
  status: PropTypes.bool,
  filters: PropTypes.string,
  handleEditAction: PropTypes.func,
  handleDeleteAction: PropTypes.func,
  handleApplyAction: PropTypes.func,
  handleCloneAction: PropTypes.func,
  handleCheckCloneAction: PropTypes.func,
};

export default ActionCell;
